export interface DataTableTranslations {
	headerReload: string,
	headerColumnSelector: string,
	indexColumn: string;
	selectColumn: string;
	selectRow: string;
	selectAllRows: string,
	expandColumn: string;
	expandRow: string;
	paginationLimit: string;
	paginationRange: string;
}
